// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as Tz$LiteracyplanetSharedClientProfile from "@literacyplanet/shared-client-profile/src/Tz.res.mjs";
import * as HasuraTypes$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/HasuraTypes.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as MutationHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/MutationHook2.res.mjs";
import * as BadgesContext$LiteracyplanetClientSxEntry from "./BadgesContext.res.mjs";
import * as BadgesQuery$LiteracyplanetSharedClientProfile from "@literacyplanet/shared-client-profile/src/BadgesQuery.res.mjs";

var Q = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: BadgesQuery$LiteracyplanetSharedClientProfile.BadgesQuery.Raw,
      use: BadgesQuery$LiteracyplanetSharedClientProfile.BadgesQuery.use,
      useFetch: BadgesQuery$LiteracyplanetSharedClientProfile.BadgesQuery.useFetch
    });

var Raw = {};

var query = GraphqlTag.gql(["mutation AwardBadges($awardBadges: [ID!]!, $userId: String!, $zone: String!)  {\nawardBadges(awardBadges: $awardBadges, userId: $userId, zone: $zone)  \n}\n"]);

function parse(value) {
  var value$1 = value.awardBadges;
  return {
          awardBadges: value$1.map(function (value) {
                return value;
              })
        };
}

function serialize(value) {
  var value$1 = value.awardBadges;
  var awardBadges = value$1.map(function (value) {
        return value;
      });
  return {
          awardBadges: awardBadges
        };
}

function serializeVariables(inp) {
  var a = inp.awardBadges;
  return {
          awardBadges: a.map(function (b) {
                return b;
              }),
          userId: inp.userId,
          zone: inp.zone
        };
}

function makeVariables(awardBadges, userId, zone, param) {
  return {
          awardBadges: awardBadges,
          userId: userId,
          zone: zone
        };
}

var AwardBadges_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Mutation.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useWithState = include.useWithState;

var AwardBadges = {
  AwardBadges_inner: AwardBadges_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useWithState: useWithState
};

var M = MutationHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useWithState: useWithState
    });

function BadgesProvider(props) {
  FlagsContext$LiteracyplanetClientFlags.use();
  var $$fetch = Q.useAsync();
  var award = M.useAsync("BadgesProvider - AwardBadges error");
  var badges = React.useRef({});
  var getBadges = async function (userId) {
    var badges$1 = Js_dict.get(badges.current, userId);
    if (badges$1 !== undefined) {
      return badges$1;
    }
    var res = await $$fetch({
          userId: HasuraTypes$LiteracyplanetClientFlags.encode(userId)
        });
    if (res === undefined) {
      return [];
    }
    var b = BadgesQuery$LiteracyplanetSharedClientProfile.parseBadges(res.badges);
    badges.current[userId] = b;
    return b;
  };
  var awardBadges = async function (awardBadges$1, userId) {
    var badgeIds = Belt_Array.map(awardBadges$1, (function (b) {
            return b.badgeId;
          }));
    if (badgeIds.length === 0) {
      return ;
    }
    var zone = Tz$LiteracyplanetSharedClientProfile.getUsersTimeZone();
    var match = await award({
          awardBadges: badgeIds,
          userId: userId,
          zone: zone
        });
    Belt_Option.map(match.data, (function (param) {
            var awardBadges = param.awardBadges;
            var currBadges = Js_dict.get(badges.current, userId);
            if (currBadges !== undefined) {
              badges.current[userId] = currBadges.filter(function (param) {
                    return !awardBadges.includes(param.badgeId);
                  });
              return ;
            }
            
          }));
  };
  return React.createElement(BadgesContext$LiteracyplanetClientSxEntry.Provider.make, {
              value: {
                getBadges: getBadges,
                awardBadges: awardBadges
              },
              children: props.children
            });
}

var make = BadgesProvider;

export {
  Q ,
  AwardBadges ,
  M ,
  make ,
}
/* Q Not a pure module */
